import React, { Component } from 'react'
import EditorContainer from '../../components/viewer/EditorContainer'

export default class ViewerPage extends Component {
    render() {
        return (
            <EditorContainer></EditorContainer>
        )
    }
}
